import apiService from '../Api'

/** Opção do campo "Origem" do registro manual de leads. */
export interface ILeadSource {
  id: number
  name: string
}

export class LeadSourceService {
  async list(): Promise<ILeadSource[]> {
    return apiService.get('/lead-sources').then((response) => response.data)
  }

  async create(name: string): Promise<ILeadSource> {
    return apiService.post('/lead-sources', { name }).then((response) => response.data)
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`/lead-sources/${id}`)
  }
}
